@if (report) {
	<div>
		<div
			class="graph"
			[class.one-level]="report.rubricLevels.length === 1"
			[class.two-levels]="report.rubricLevels.length === 2"
			[class.three-levels]="report.rubricLevels.length === 3"
			[class.four-levels]="report.rubricLevels.length === 4"
			[class.five-levels]="report.rubricLevels.length === 5"
			[class.six-levels]="report.rubricLevels.length === 6"
			[class.seven-levels]="report.rubricLevels.length === 7"
			[class.eight-levels]="report.rubricLevels.length === 8"
			[class.nine-levels]="report.rubricLevels.length === 9"
			[class.ten-levels]="report.rubricLevels.length === 10"
		>
			<div class="bg">
				@for (level of report.rubricLevels; track level) {
					<div class="level" [ngClass]="'level' + level.level + '-color'">
						<div class="color-bar"></div>
						<div class="level-name">{{ level.name }}</div>
					</div>
				}
			</div>
			<div class="bars-container">
				@if (selectedProgress) {
					<div class="bars">
						@for (bar of selectedProgress; track bar; let i = $index) {
							<div
								class="bar"
								[class.selected]="selectedItem === bar"
								[class.level1]="bar.contentRubricLevel === 1"
								[class.level2]="bar.contentRubricLevel === 2"
								[class.level3]="bar.contentRubricLevel === 3"
								[class.level4]="bar.contentRubricLevel === 4"
								[class.level5]="bar.contentRubricLevel === 5"
								[class.level6]="bar.contentRubricLevel === 6"
								[class.level7]="bar.contentRubricLevel === 7"
								[class.level8]="bar.contentRubricLevel === 8"
								[class.level9]="bar.contentRubricLevel === 9"
								[class.level10]="bar.contentRubricLevel === 10"
								[class.was-upgraded]="
									i > 0 && selectedProgress[i - 1].contentRubricLevel < bar.contentRubricLevel
								"
								[class.was-downgraded]="
									i > 0 && selectedProgress[i - 1].contentRubricLevel > bar.contentRubricLevel
								"
								[nz-tooltip]="
									'Activity: ' +
									(i + 1) +
									', Difficulty: ' +
									bar.contentRubricLevel +
									', Performance: ' +
									(bar.assessment?.rubricLevel || bar.skillHistory.rubric_level_level) +
									', Score: ' +
									(bar.take.percentage ? bar.take.percentage + '%' : 'N/A') +
									', Date: ' +
									(bar.take.start_date | date: 'mediumDate')
								"
								(click)="toggleSelectedItem(bar)"
							>
								<div class="upgraded">
									<svg
										viewBox="-0.266602 73.0111 18 15.9768"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<g clip-path="url(#clip0_2659_2349)">
											<path
												d="M0.200275 88.9612C0.0639856 88.9141 -0.0542544 88.8253 -0.137949 88.7074C-0.221644 88.5895 -0.26662 88.4483 -0.266602 88.3034C-0.266602 85.1253 0.368593 82.5838 1.62211 80.7486C3.13654 78.5314 5.52544 77.3375 8.73343 77.1893V73.6956C8.73344 73.5593 8.77325 73.4261 8.84793 73.3125C8.9226 73.1988 9.02884 73.1096 9.15348 73.056C9.27812 73.0025 9.41567 72.9869 9.54906 73.0111C9.68246 73.0354 9.80583 73.0985 9.90387 73.1925L17.5193 80.4965C17.587 80.5614 17.6408 80.6395 17.6776 80.7259C17.7144 80.8124 17.7334 80.9055 17.7334 80.9995C17.7334 81.0935 17.7144 81.1866 17.6776 81.273C17.6408 81.3595 17.587 81.4376 17.5193 81.5025L9.90387 88.8064C9.80583 88.9005 9.68246 88.9636 9.54906 88.9879C9.41567 89.0121 9.27812 88.9965 9.15348 88.9429C9.02884 88.8894 8.9226 88.8002 8.84793 88.6865C8.77325 88.5728 8.73344 88.4396 8.73343 88.3034V84.8354C6.78631 84.8945 5.31515 85.2114 4.14385 85.8197C2.87822 86.477 1.96047 87.4591 0.971336 88.7325C0.8826 88.8467 0.760606 88.9302 0.622379 88.9713C0.484151 89.0125 0.336586 89.0093 0.200275 88.9621V88.9612Z"
												fill="#000000"
											/>
										</g>
										<defs>
											<clipPath id="clip0_2659_2349">
												<rect
													x="-0.266602"
													y="73.0111"
													width="18"
													height="15.9768"
													fill="white"
												/>
											</clipPath>
										</defs>
									</svg>
								</div>
								<div class="downgraded">
									<svg
										viewBox="2.33301 36.0091 14.62499 12.9394"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M2.71234 36.0306C2.60161 36.0688 2.50554 36.1405 2.43754 36.2359C2.36954 36.3312 2.33299 36.4454 2.33301 36.5625C2.33301 39.1325 2.8491 41.1877 3.86758 42.6717C5.09805 44.4646 7.03902 45.43 9.64551 45.5499V48.375C9.64552 48.4852 9.67786 48.5929 9.73853 48.6848C9.7992 48.7768 9.88553 48.8489 9.9868 48.8922C10.0881 48.9355 10.1998 48.9481 10.3082 48.9285C10.4166 48.9089 10.5168 48.8579 10.5965 48.7818L16.784 42.8756C16.839 42.823 16.8827 42.7599 16.9126 42.69C16.9425 42.6201 16.958 42.5448 16.958 42.4688C16.958 42.3928 16.9425 42.3175 16.9126 42.2476C16.8827 42.1777 16.839 42.1146 16.784 42.062L10.5965 36.1558C10.5168 36.0797 10.4166 36.0287 10.3082 36.0091C10.1998 35.9895 10.0881 36.0021 9.9868 36.0454C9.88553 36.0887 9.7992 36.1608 9.73853 36.2528C9.67786 36.3447 9.64552 36.4524 9.64551 36.5625V39.367C8.06348 39.3191 6.86816 39.0629 5.91648 38.571C4.88816 38.0395 4.1425 37.2453 3.33883 36.2156C3.26673 36.1232 3.16761 36.0557 3.0553 36.0225C2.94299 35.9892 2.8231 35.9918 2.71234 36.0299V36.0306Z"
											fill="#000000"
										/>
									</svg>
								</div>
								<div
									class="assessment-level"
									[class.level1]="
										(bar.assessment?.rubricLevel || bar.skillHistory.rubric_level_level) === 1
									"
									[class.level2]="
										(bar.assessment?.rubricLevel || bar.skillHistory.rubric_level_level) === 2
									"
									[class.level3]="
										(bar.assessment?.rubricLevel || bar.skillHistory.rubric_level_level) === 3
									"
									[class.level4]="
										(bar.assessment?.rubricLevel || bar.skillHistory.rubric_level_level) === 4
									"
									[class.level5]="
										(bar.assessment?.rubricLevel || bar.skillHistory.rubric_level_level) === 5
									"
									[class.level6]="
										(bar.assessment?.rubricLevel || bar.skillHistory.rubric_level_level) === 6
									"
									[class.level7]="
										(bar.assessment?.rubricLevel || bar.skillHistory.rubric_level_level) === 7
									"
									[class.level8]="
										(bar.assessment?.rubricLevel || bar.skillHistory.rubric_level_level) === 8
									"
									[class.level9]="
										(bar.assessment?.rubricLevel || bar.skillHistory.rubric_level_level) === 9
									"
									[class.level10]="
										(bar.assessment?.rubricLevel || bar.skillHistory.rubric_level_level) === 10
									"
								>
									{{ bar.assessment?.rubricLevel || bar.skillHistory.rubric_level_level }}
								</div>
								<div class="activity-number">{{ i + 1 }}</div>
							</div>
						}
					</div>
				}
			</div>
			<div class="footer">Activity #</div>
		</div>
	</div>
}
